import { Order, OrderItem } from '../../../../types/interfaces';
import { NumberFormatter } from '../../../../shared/ui/number-formatter';

const thCls = "p-[1.3rem] text-[#9b9fac] text-[15px] font-medium border-b border-[#e9edf2] text-left";
const tdCls = "p-3 font-medium text-[#242426] align-top";

export function DeliveryItemsInfo({ order }: { order: Order }) {
  return (
    <table className="w-full">
      <thead>
        <tr>
          <th className={thCls} style={{ width: '20%' }}>Наименование изделия</th>
          <th className={thCls} style={{ width: '10%' }}>Количество</th>
          <th className={thCls} style={{ width: '15%' }}>Цена за единицу</th>
          <th className={thCls} style={{ width: '15%' }}>Общая стоимость</th>
        </tr>
      </thead>
      <tbody>
        {order.items.map((item: OrderItem, index: number) => (
          <tr key={index}>
            <td
              className={tdCls}
              style={{
                color: item.cancel ? 'gray' : 'black',
                textDecoration: item.cancel ? 'line-through' : 'none',
              }}
            >
              {item.item_name}
            </td>
            <td className={tdCls}>
              <NumberFormatter number={item.quantity} />
            </td>
            <td className={tdCls}>
              <NumberFormatter number={+item.price} />
            </td>
            <td className={tdCls}>
              <NumberFormatter number={+item.price * +item.quantity} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
